import { tracked } from "@glimmer/tracking";

class CommunityNavigationSelection {
  @tracked primaryKey = "public";
}

export default new CommunityNavigationSelection();
